import { render, staticRenderFns } from "./NavbarDashboard.vue?vue&type=template&id=4d551af2&scoped=true"
import script from "./NavbarDashboard.vue?vue&type=script&lang=js"
export * from "./NavbarDashboard.vue?vue&type=script&lang=js"
import style0 from "./NavbarDashboard.vue?vue&type=style&index=0&id=4d551af2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d551af2",
  null
  
)

export default component.exports